import { defineStore, createPinia } from 'pinia';
import piniaPersistConfig from '@/config/piniaPersist';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { menuData } from './menuData';
import { getUserInfo as getUserInfoApi } from '@/api/modules/login';

export const GlobalStore = defineStore({
	id: 'GlobalState',
	// state
	state: () => ({
		isUserFirstLogin: true, // 필수 첫로그인으로 비번변경 요구됨.
		isUserPwReset: true, // 필수 비번리셋으로 비번변경 요구됨.
		isUserPwExpired: true, // 필수 비번기간만료로 비번변경 요구됨.

		token: null,
		retoken: null,
		isRefreshingToken: false,

		// userInfo 기본정보
		userInfo: {
			academyCode: 'AA713761',
			academyName: '문해력전문학원',
			academyPhone: '0212345678',
			address: '',
			addressDetail: '',
			birthday: '        ',
			grade: 'P5',
			loginId: '',
			postcode: '     ',
			protectorEmail: '',
			protectorName: '',
			protectorPhone: '',
			schoolName: '가가초등학교',
			soundYn: true,
			studentEmail: '',
			studentName: '',
			studentPhone: '',
			studentSeq: 1260,
			systemGubunCode: '2',
			productCode: 'RT',
		},

		version: '',
		sound: false, //  효과음 (로그인 성공 후  삽입)
		loginCount: 0,
		loginMillis: 0,
		appVersion: null,
		platform: 'DESKTOP', // ANDROID, IOS, DESKTOP

		////////////----진단평가----////////////
		token_eval: '', // 진단평가용 토큰
		retoken_eval: '', // 진단평가용 리토큰
		version_eval: '1.00.01', // 진단평가용  버전
		// 6/2추가
		selected_kread: '', // 선택한 크리드
		evalData: {
			nick: '', //   nick
			real_grade: '', //   학년 (시작크리드와 다름, 예비중은 P1이기때문에)
			academy_code: '', // 학원코드
			first_kread: '', //  시작레슨  'M1'
			start_kread: -1, // 시작크리드  1300, 1400, 1500
			is_eval: true, // 진단 or 수능
			is_study: false, // 풀이인지
		},

		////////////----페이지_이동----////////////
		is_member_eval: false, // 페이지 진입 분기 : 멤버용 진단평가 여부
		is_private: true, // 페이지 진입 분기 : 개인정보처리방침 or 이용약관
		is_notice_inform: false, // 페이지 진입 분기 :  공지사항  from
		is_from_mypage: false, // 알림 진입  from mypage
		study_inform: null, // 학습알림 data in 마이페이지

		examsData: [],
		examsDataEx: [],
		examsDataSat: [],

		// 로그인 경로 (성장판:growthplate/마카다미아:macadamia)
		loginRoot: '',
		// 비밀번호 변경 여부 (성장판 로그인 시 무조건 'growthplate')
		audience: '',
		// 성장판앱 로그아웃 경로 (성장판홈: HOME / 성장찬 자기점검: COACHING)
		logoutPath: '',
		//성장판 넘겨받은 정보
		growthData: {},
	}),
	getters: {
		getProductCode(state) {
			// gStore.initStore() 토큰정보 삭제에 따른 예외처리
			if (state.userInfo?.productCode?.indexOf('DT') == -1) {
				return 'RT';
			} else {
				return 'DT';
			}
		},
	},
	actions: {
		setIsUserFirstLogin(bool) {
			this.isUserFirstLogin = bool;
		},
		setIsUserPwReset(bool) {
			this.isUserPwReset = bool;
		},
		setIsUserPwExpired(bool) {
			this.isUserPwExpired = bool;
		},

		setToken(token) {
			this.token = token;
			console.log('global store token ===', this.token);
		},
		setReToken(token) {
			this.retoken = token;
			console.log('global store retoken ===', this.retoken);
		},
		setVersion(version) {
			this.version = version;
		},

		setSound(bool) {
			this.sound = bool;
		},

		setUserInfo(userInfo) {
			this.userInfo = userInfo;
		},

		// for 진단평가
		setTokenForEval(token) {
			this.token_eval = token;
		},
		setReTokenForEval(reToken) {
			this.retoken_eval = reToken;
		},
		setVersionForEval(version) {
			this.version_eval = version;
		},
		setEvalData(info) {
			this.evalData = info;
		},
		setEvalRealGrade(data) {
			this.evalData.real_grade = data;
		},
		setEvalStudentGradeCode(data) {
			this.evalData.first_kread = data;
		},
		setEvalStartKread(data) {
			this.evalData.start_kread = data;
		},

		setIsMemberEval(bool) {
			this.is_member_eval = bool;
		},
		setIsPrivate(bool) {
			this.is_private = bool;
		},
		setIsNoticeInform(bool) {
			this.is_notice_inform = bool;
		},
		setIsFromMypage(bool) {
			this.is_from_mypage = bool;
		},
		setStudyInform(obj) {
			this.study_inform = obj;
		},
		setPlatform(str) {
			this.platform = str;
		},
		setExamsData(str) {
			this.examsData.push(str);
		},
		setExamsDataEx(str) {
			this.examsDataEx.push(str);
		},
		setExamsDataSat(str) {
			this.examsDataSat.push(str);
		},
		setGrowthData(obj) {
			this.growthData = obj;
		},
		setIsRefreshingToken(bool) {
			this.isRefreshingToken = bool;
		},
		setSelectedKread(str) {
			this.selected_kread = str;
		},

		async getUserInfo() {
			return await getUserInfoApi(rs => {
				this.userInfo = rs;
				this.sound = rs?.soundYn;
				this.setIsMemberEval(true);

				console.log('pinia getUserInfo  ===', this.userInfo);
				return this.userInfo;
			});
		},
		async initStore() {
			this.isRequireChangePW = true;
			this.token = null;
			this.retoken = null;
			// userInfo_기본정보
			this.userInfo = {};
			this.version = '1.00.01';
			this.sound = false;
			this.loginCount = 0;
			this.loginMillis = 0;
			this.appVersion = null;
			this.platform = 'DESKTOP';
			// 진단평가용
			this.token_eval = null; // 진단평가용 토큰
			this.retoken_eval = null; // 진단평가용 refresh토큰
			this.version_eval = ''; // 진단평가용  버전
			this.evalData = {};
			this.is_member_eval = undefined; // 페이지 진입 분기 : 멤버용 진단평가 여부
			this.is_private = true; // 페이지 진입 분기 : 개인정보처리방침 or 이용약관
			this.study_inform = null; // 학습알림 in 마이페이지
			//진단평가 학년 초기화
			this.selected_kread = '';

			// init 추가
			this.audience = '';
			this.logoutPath = '';
		},
		initToken() {
			// token만 초기화 - is_member_eval은 사용가능성 있음.
			this.token = null;
			this.retoken = null;
			this.token_eval = null; // 진단평가용 토큰
			this.retoken_eval = null; // 진단평가용 refresh토큰
		},

		setLoginRoot(str) {
			this.loginRoot = str;
			console.log('setLoginRoot ===', this.loginRoot);
		},

		setAudience(str) {
			this.audience = str;
			console.log('setAudience ===', this.audience);
		},

		setLogoutPath(str) {
			this.logoutPath = str;
			console.log('setLogoutPath ===', this.logoutPath);
		},
	},
	persist: piniaPersistConfig('GlobalState'),
});

// piniaPersist
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

export default pinia;
